import { styled } from '@mui/material/styles';
import { COLORS } from '../../../constants/radar';

export const MainContainer = styled('div')(({ theme, show }) => ({
  background: 'white',
  borderRadius: '8px',
  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
  padding: '24px',
  flex: 1,
  overflowY: 'auto',
  marginTop: 0,
  transition: 'all 0.3s ease',
}));

export const MatrixGrid = styled('div')({
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fill, minmax(400px, 1fr))',
  gap: '24px',
  width: '100%',
  alignItems: 'start',
});

export const MatrixCard = styled('div')({
  backgroundColor: '#f8f9fa',
  borderRadius: '4px',
  border: '1px solid #e0e0e0',
  transition: 'all 0.2s',
  alignSelf: 'start',

  '&:hover': {
    backgroundColor: '#f1f3f5',
    borderColor: '#bdbdbd',
  }
});

export const MatrixCardContent = styled('div')({
  padding: '16px',
  display: 'flex',
  flexDirection: 'column',
  minHeight: '200px',
});

export const MatrixTitle = styled('div')({
  margin: 0,
  fontWeight: 600,
  color: COLORS.PRIMARY,
  marginBottom: '4px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
});

export const MatrixDetailsGrid = styled('div')({
  fontSize: '14px',
  color: '#666',
  marginTop: '16px',
  marginBottom: '8px',
  lineHeight: 1.4,
  flex: 1,
})
export const ItalicText = styled('span')({
  color: '#94A3B8',
  fontStyle: 'italic',
});

export const ActionButtons = styled('div')({
  display: 'flex',
  justifyContent: 'flex-end',
  gap: '8px',
  marginTop: 'auto',
}); 